exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module{\r\n    opacity:.4;\r\n    padding-right:10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/toolbox/toolbox.component.css
// module id = ../../../../../src/app/toolbox/toolbox.component.css
// module chunks = 1